var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuggestionBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M10.2,37.5h24.7c0.2,0,0.4-0.2,0.4-0.4v-3c0-0.2-0.2-0.4-0.4-0.4h-0.5V18.3h0.5c0.2,0,0.4-0.2,0.4-0.4v-3.1 c0-0.2-0.2-0.3-0.4-0.3h-4.1V7.9c0-0.2-0.1-0.4-0.3-0.4H14.5c-0.2,0-0.4,0.2-0.4,0.4v6.6h-4c-0.2,0-0.4,0.1-0.4,0.3v3.1 c0,0.2,0.2,0.4,0.4,0.4h0.4v15.4h-0.4c-0.2,0-0.4,0.2-0.4,0.4v3C9.8,37.3,9.9,37.5,10.2,37.5z M15,8.3H30v6.2H15V8.3z M10.5,15.2 h24v2.3h-24V15.2z M11.3,18.3h22.3v15.4H11.3V18.3z M10.5,34.4h24v2.3h-24V34.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 15.2,
    fill: "#C9C9C9",
    width: 24,
    height: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M33.7,33.7V18.3H11.3v15.4H33.7z M26.8,21.7c2.3,2.2,2.3,5.9,0.1,8.2h-0.1c-0.2,0.2-0.1,0-0.1,0.3 s0.4,0.5,0.6,0.6c0.2,0.1,0.2,0.4,0.2,0.5c0,0.1,0,0.2-0.2,0.3c-0.5,0.3-1,0.4-1.5,0.4c-0.6,0-1.1-0.2-1.6-0.6 c-2.1,0.6-4.3,0.1-5.8-1.5c-0.3-0.3-0.6-0.5-0.8-0.9c-2-2.6-1.6-6.3,0.9-8.3C21,18.7,24.7,19.1,26.8,21.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 34.4,
    fill: "#C9C9C9",
    width: 24,
    height: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M30,14.5V8.3H15v6.2H30z M17.2,12.6c0-0.2,0.2-0.4,0.4-0.4h1.5c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.3-0.4,0.3h-1.5C17.5,12.9,17.2,12.8,17.2,12.6z M21.2,12.6c0-0.2,0.2-0.4,0.4-0.4h5.7c0.2,0,0.3,0.2,0.3,0.4 c0,0.2-0.1,0.3-0.3,0.3h-5.7C21.5,12.9,21.2,12.8,21.2,12.6z M21.7,10h5.7c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.4-0.3,0.4h-5.7 c-0.2,0-0.4-0.2-0.4-0.4C21.2,10.1,21.5,10,21.7,10z M17.7,10h1.5c0.2,0,0.4,0.1,0.4,0.3c0,0.2-0.2,0.4-0.4,0.4h-1.5 c-0.2,0-0.4-0.2-0.4-0.4C17.2,10.1,17.5,10,17.7,10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M19.2,12.9c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.2-0.4-0.4-0.4h-1.5c-0.2,0-0.4,0.2-0.4,0.4 c0,0.2,0.2,0.3,0.4,0.3H19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M27.3,12.9c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.4-0.3-0.4h-5.7c-0.2,0-0.4,0.2-0.4,0.4 c0,0.2,0.2,0.3,0.4,0.3H27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M17.2,10.3c0,0.2,0.2,0.4,0.4,0.4h1.5c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.3-0.4-0.3h-1.5 C17.5,10,17.2,10.1,17.2,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M21.2,10.3c0,0.2,0.2,0.4,0.4,0.4h5.7c0.2,0,0.3-0.2,0.3-0.4c0-0.2-0.1-0.3-0.3-0.3h-5.7 C21.5,10,21.2,10.1,21.2,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M18.5,20.8c-2.6,2-3,5.7-0.9,8.3c0.2,0.3,0.5,0.6,0.8,0.9c1.5,1.6,3.7,2.1,5.8,1.5c0.5,0.4,1,0.6,1.6,0.6 c0.5,0,1-0.1,1.5-0.4c0.2-0.1,0.2-0.2,0.2-0.3c0-0.1,0-0.4-0.2-0.5c-0.2-0.1-0.6-0.3-0.6-0.6s-0.1-0.1,0.1-0.3h0.1 c2.2-2.3,2.2-6-0.1-8.2C24.7,19.1,21,18.7,18.5,20.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestionBox);
export default __webpack_public_path__ + "static/media/suggestion_box.dfbfb50003f1a71c4388a9b346c7f724.svg";
export { ForwardRef as ReactComponent };